<template>
  <div class="delegated-account">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>委托账户</span>
      </div>

      <!-- 搜索栏 -->
      <div class="filter-bar">
        <el-select
          v-model="query.company_id"
          placeholder="选择委托账户"
          clearable
          style="width: 240px; margin-right: 12px;"
          :disabled="companies.length === 1"
          @change="getList"
        >
          <el-option v-for="c in companies" :key="c.id" :label="c.company_name" :value="c.id" />
        </el-select>
        <el-input
          v-model="query.keyword"
          placeholder="会员昵称/手机号"
          clearable
          style="width: 220px; margin-right: 12px;"
          @keyup.enter.native="handleSearch"
        />
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      </div>

      <el-table :data="list" border stripe v-loading="loading" style="width: 100%">
        <el-table-column prop="member_id" label="会员ID" width="90" />
        <el-table-column prop="member_name" label="会员昵称" min-width="130" />
        <el-table-column prop="member_phone" label="手机号" width="130" />
        <el-table-column label="委托账户" min-width="180">
          <template slot-scope="scope">{{ companyName(scope.row.company_id) }}</template>
        </el-table-column>
        <el-table-column label="累计到账" width="120">
          <template slot-scope="scope">
            <span style="color: #E6A23C; font-weight: bold;">￥{{ scope.row.total_income }}</span>
          </template>
        </el-table-column>
        <el-table-column label="当前委托到账金额" width="150">
          <template slot-scope="scope">
            <span style="color: #C91623; font-weight: bold;">￥{{ scope.row.delegated_balance }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="audited_at" label="审核通过时间" width="170" />
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleTransfer(scope.row)">转账结清</el-button>
            <el-button type="text" size="small" @click="handleFlowLogs(scope.row)">流水明细</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap" v-if="total > 0">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="query.limit"
          :current-page.sync="query.page"
          @current-change="getList"
        />
      </div>
    </el-card>

    <!-- 转账结清弹窗 -->
    <el-dialog title="转账结清" :visible.sync="transferVisible" width="520px" :close-on-click-modal="false">
      <el-form ref="transferForm" :model="transferForm" :rules="transferRules" label-width="110px">
        <el-form-item label="会员">
          <span>{{ transferForm.member_name }}（ID: {{ transferForm.member_id }}）</span>
        </el-form-item>
        <el-form-item label="当前到账金额">
          <span style="color: #C91623; font-weight: bold;">￥{{ transferForm.delegated_balance }}</span>
        </el-form-item>
        <el-form-item label="转账金额" prop="amount">
          <el-input v-model="transferForm.amount" type="number" placeholder="请输入转账金额" />
          <div class="form-tip">转账后将从该会员的委托到账金额中扣减</div>
        </el-form-item>
        <el-form-item label="转账凭证" prop="voucher">
          <div class="upload-wrap">
            <el-input v-model="transferForm.voucher" placeholder="转账凭证图片URL" style="flex: 1;" />
            <el-upload
              class="upload-btn"
              action="https://api-lefeng365.linhebj.top/api/v1/manger/upload"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="handleVoucherUploadSuccess"
              :before-upload="beforeUpload"
              accept="image/*"
            >
              <el-button size="small" icon="el-icon-upload">上传</el-button>
            </el-upload>
          </div>
          <img v-if="transferForm.voucher" :src="transferForm.voucher" class="img-preview" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="transferForm.remark" type="textarea" :rows="2" placeholder="备注说明" maxlength="500" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="transferVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleTransferSubmit">确定转账</el-button>
      </div>
    </el-dialog>

    <!-- 流水明细弹窗 -->
    <el-dialog title="委托到账流水" :visible.sync="flowVisible" width="720px" :close-on-click-modal="false">
      <div class="flow-header" v-if="flowMember">
        会员：{{ flowMember.name }}（ID: {{ flowMember.member_id }}）　当前到账金额：<span style="color: #C91623; font-weight: bold;">￥{{ flowMember.delegated_balance }}</span>
      </div>
      <el-table :data="flowList" border stripe v-loading="flowLoading" size="small" style="width: 100%">
        <el-table-column prop="create_time" label="时间" width="160" />
        <el-table-column prop="type_label" label="类型" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 'income' ? 'success' : 'warning'" size="small">{{ scope.row.type_label }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="金额" width="120">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.type === 'income' ? '#67C23A' : '#E6A23C', fontWeight: 'bold' }">
              {{ scope.row.type === 'income' ? '+' : '' }}{{ scope.row.amount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="order_no" label="订单号" width="180">
          <template slot-scope="scope">{{ scope.row.order_no || '-' }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" />
        <el-table-column label="凭证" width="80">
          <template slot-scope="scope">
            <el-button v-if="scope.row.voucher" type="text" size="small" @click="previewVoucher(scope.row.voucher)">查看</el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap" v-if="flowTotal > 0">
        <el-pagination
          background
          small
          layout="total, prev, pager, next"
          :total="flowTotal"
          :page-size="flowQuery.limit"
          :current-page.sync="flowQuery.page"
          @current-change="loadFlowLogs"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDelegatedAccountMembers,
  transferDelegatedAccount,
  getDelegatedAccountFlowLogs
} from '@/api'

export default {
  name: 'DelegatedAccount',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      companies: [],
      currentCompanyId: null,
      query: { page: 1, limit: 15, company_id: '', keyword: '' },
      // 转账
      transferVisible: false,
      transferForm: {
        member_id: null,
        member_name: '',
        delegated_balance: '0.00',
        amount: '',
        voucher: '',
        remark: ''
      },
      transferRules: {
        amount: [
          { required: true, message: '请输入转账金额', trigger: 'blur' },
          { validator: (rule, value, cb) => {
            if (value === '' || value === null || value === undefined) return cb()
            const num = Number(value)
            if (isNaN(num) || num <= 0) return cb(new Error('转账金额必须大于0'))
            if (num > Number(this.transferForm.delegated_balance)) return cb(new Error('转账金额不能超过当前到账金额'))
            cb()
          }, trigger: 'blur' }
        ]
      },
      submitLoading: false,
      // 流水
      flowVisible: false,
      flowLoading: false,
      flowList: [],
      flowTotal: 0,
      flowMember: null,
      flowQuery: { page: 1, limit: 10 }
    }
  },
  computed: {
    uploadHeaders() {
      const token = localStorage.getItem('admin_token')
      return token ? { Authorization: `Bearer ${token}` } : {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    companyName(id) {
      const c = this.companies.find(item => item.id === id)
      return c ? c.company_name : '-'
    },
    handleSearch() {
      this.query.page = 1
      this.getList()
    },
    getList() {
      this.loading = true
      const params = { page: this.query.page, limit: this.query.limit }
      if (this.query.company_id) params.company_id = this.query.company_id
      if (this.query.keyword) params.keyword = this.query.keyword
      getDelegatedAccountMembers(params).then(res => {
        this.list = res.data || []
        this.total = res.total || 0
        this.companies = res.companies || []
        this.currentCompanyId = res.current_company_id || null
      }).catch(() => {
        this.$message.error('获取列表失败')
      }).finally(() => { this.loading = false })
    },
    handleTransfer(row) {
      this.transferForm = {
        member_id: row.member_id,
        member_name: row.member_name,
        delegated_balance: row.delegated_balance,
        amount: '',
        voucher: '',
        remark: ''
      }
      this.transferVisible = true
      this.$nextTick(() => this.$refs.transferForm && this.$refs.transferForm.clearValidate())
    },
    handleTransferSubmit() {
      this.$refs.transferForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        transferDelegatedAccount({
          member_id: this.transferForm.member_id,
          amount: this.transferForm.amount,
          voucher: this.transferForm.voucher,
          remark: this.transferForm.remark
        }).then(() => {
          this.$message.success('转账成功')
          this.transferVisible = false
          this.getList()
        }).catch(err => {
          this.$message.error(err.message || '转账失败')
        }).finally(() => { this.submitLoading = false })
      })
    },
    handleFlowLogs(row) {
      this.flowMember = {
        member_id: row.member_id,
        name: row.member_name,
        delegated_balance: row.delegated_balance
      }
      this.flowList = []
      this.flowTotal = 0
      this.flowQuery.page = 1
      this.flowVisible = true
      this.loadFlowLogs()
    },
    loadFlowLogs() {
      this.flowLoading = true
      getDelegatedAccountFlowLogs({
        member_id: this.flowMember.member_id,
        page: this.flowQuery.page,
        limit: this.flowQuery.limit
      }).then(res => {
        this.flowList = res.data || []
        this.flowTotal = res.total || 0
      }).catch(() => {
        this.$message.error('获取流水失败')
      }).finally(() => { this.flowLoading = false })
    },
    previewVoucher(url) {
      window.open(url, '_blank')
    },
    // 图片上传
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (file.size / 1024 / 1024 > 5) {
        this.$message.error('图片大小不能超过5MB')
        return false
      }
      return true
    },
    handleVoucherUploadSuccess(response) {
      if (response.result === 'ok') {
        this.transferForm.voucher = response.message
      } else {
        this.$message.error(response.message || '上传失败')
      }
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.filter-bar {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}
.pagination-wrap {
  margin-top: 16px;
  text-align: right;
}
.form-tip {
  font-size: 12px;
  line-height: 1.5;
  color: #909399;
  margin-top: 4px;
}
.upload-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}
.upload-btn {
  flex-shrink: 0;
}
.img-preview {
  margin-top: 8px;
  max-width: 200px;
  max-height: 120px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
.flow-header {
  margin-bottom: 12px;
  font-size: 14px;
  color: #333;
}
</style>
